<template>
  <div>
    <div class="filterBg base-form-div">
      <el-form
        size="mini"
        :model="searchForm"
        label-position="right"
        label-width="100px"
        inline
      >
        <el-form-item label="所属公司:">
          <el-select
            v-model="searchForm.deviceGroupId"
            placeholder="请选择所属公司"
            clearable
            filterable
            style="width: 150px"
          >
            <el-option
              v-for="item in GroupSelect"
              :label="item.name"
              :value="item.id"
              :key="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="飞机型号:">
          <el-select
            v-model="searchForm.planeType"
            placeholder="请选择飞机型号"
            clearable
            filterable
            style="width: 150px"
          >
            <el-option
              v-for="option in aircraftOptions"
              :key="option.value"
              :label="option.label"
              :value="option.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="北斗卡号:">
          <el-input
            v-model="searchForm.sendCardNumber"
            placeholder="请输入"
            class="filter-item"
            clearable
            @keyup.enter.native="handleFilter"
            @clear="handleFilter"
            style="width: 150px"
          />
        </el-form-item>
        <el-form-item label="飞行日期:">
          <el-date-picker
            class="flightDateClassBg"
            v-model="flightDate"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetimerange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']"
            style="width: 200px"
            @change="setFlightDateTime"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div style="padding-top: 7px; box-sizing: border-box">
        <!-- <el-button
          class="base-button"
          size="mini"
          icon="el-icon-video-play"
          @click="pathLine"
          type="success"
          >轨迹回放</el-button
        > -->
        <el-button
          class="base-button"
          size="mini"
          type="primary"
          icon="el-icon-search"
          @click="handleFilter"
          >查询</el-button
        >
        <!-- <el-button
          class="base-button"
          size="mini"
          type="primary"
          icon="el-icon-download"
          @click="exportFilter"
          >导出</el-button
        > -->
      </div>
    </div>
    <div class="listTable">
      <div class="margins">
        <span></span>
        <span></span>
      </div>
      <YzTable
        max-height="420px"
        :columnApi="columns"
        :listApi="listArray"
        :searchForm="searchForm"
        :afterRequest="afterRequest"
        :autoLoad="true"
        :hasPage="false"
        ref="YzTable"
      />
    </div>
  </div>
</template>

<script>
import { getCommonAjax } from "@/api/common";
import PathAnimation from "@/utils/cesiumBD/animation/PathAnimation";
// import dataLine from "./data.js"
import {
  getIndexHK,
  getPreviousDate,
  getTodayBeginTime,
  getCurrentEndTime,
  listDeviceGroup,
} from "@/api/DK.js";
var entityArr = [];
export default {
  data() {
    return {
      GroupSelect: [],
      flightDate: [getTodayBeginTime(), getCurrentEndTime()],
      columns: "json/flightReplayLine.json?v=2",
      //listArray: "data/line/flightReplayLine.json?v=2",
      listArray: window.API_Server + "/location/indexHK",
      searchForm: {
        beginTime: getTodayBeginTime(),
        endTime: getCurrentEndTime(),
        size: 50,
      },
      aircraftOptions: [
        { label: "C90GTI", value: "C90GTI" },
        { label: "Cessna 172R", value: "Cessna 172R" },
        { label: "Kodiak 100", value: "Kodiak 100" },
        { label: "M18B", value: "M18B" },
        { label: "S-76D", value: "S-76D" },
        { label: "S2R-H80", value: "S2R-H80" },
        { label: "Y12E", value: "Y12E" },
        { label: "Y5B(D)", value: "Y5B(D)" },
        { label: "塞斯纳525奖状", value: "塞斯纳525奖状" },
        { label: "空中国王C90GTI", value: "空中国王C90GTI" },
        { label: "空中拖拉机AT802", value: "空中拖拉机AT802" },
        { label: "罗宾逊R66", value: "罗宾逊R66" },
        { label: "贝尔407", value: "贝尔407" },
        { label: "贝尔407GXi", value: "贝尔407GXi" },
        { label: "贝尔412", value: "贝尔412" },
        { label: "钻石DA20", value: "钻石DA20" },
        { label: "钻石DA40", value: "钻石DA40" },
        { label: "钻石DA40D", value: "钻石DA40D" },
        { label: "钻石DA42", value: "钻石DA42" },
      ],
    };
  },
  created() {
    window.__entityCollection__ = [];
    window.__popCollection__ = [];

    this.listDeviceGroupSelect();
  },
  mounted() {},
  beforeDestroy() {
    viewer.clock.multiplier = 1;
    this.clearData();
  },
  methods: {
    listDeviceGroupSelect() {
      listDeviceGroup()
        .then((res) => {
          console.log(res);
          this.GroupSelect = res.result || [];
        })
        .catch((err) => {
          console.error(err);
        });
    },
    clearData() {
      window.__entityCollection__.forEach((ent) => {
        ent.show = false;
      });

      window.__popCollection__.forEach((pop) => {
        pop.close();
      });

      window.__popCollection__.length = 0;
    },
    afterRequest(res) {
      let result = res.result || {};
      let items = [];
      const onLineNum = Object.keys(result).length;
      for (const key in result) {
        if (result.hasOwnProperty(key)) {
          let line = result[key];
          line.reverse();
          let arr = key.split("+");
          let row = {
            id: key,
            name: arr[0],
            aircraftModel: arr[1],
            cardNum: arr[2],
            trajectoryPoints: line,
          };

          items.push(row);
        }
      }

      return {
        result: {
          items: items,
          total: onLineNum,
        },
      };
    },
    setFlightDateTime(val) {
      if (val) {
        this.searchForm.beginTime = val[0];
        this.searchForm.endTime = val[1];
      } else {
        this.searchForm.beginTime = undefined;
        this.searchForm.endTime = undefined;
      }
    },
    removeEntityArr() {
      entityArr.forEach((item) => {
        viewer.entities.remove(item);
      });

      entityArr = [];
    },
    pathLine() {
      var entity = DBentityCollection.getById("轨迹信息");
      if (!entity) {
        this.$message({
          showClose: true,
          message: "该卡号暂无轨迹数据，无法回放！",
          type: "warning",
          duration: 3 * 1000,
        });
        return;
      }

      var positions = entity.polyline.positions.getValue();

      if (!positions || positions.length < 1) {
        this.$message({
          showClose: true,
          message: "该卡号暂无轨迹数据，无法回放！",
          type: "warning",
          duration: 3 * 1000,
        });
        return;
      }

      if (positions.length == 1) {
        this.$parent.min();
        entity.show = true;
        viewer.flyTo(entity, {
          duration: 3,
          offset: new Cesium.HeadingPitchRange(0, -Math.PI / 2, 15000), //（heading,pich,range）
        });
        return;
      }

      this.$parent.min();
      entity.show = true;
      var animation = new PathAnimation({
        entity: entity,
        positions: positions,
        speed: 1000,
        multiple: 1,
      });

      animation.start();

      viewer.flyTo(entity, {
        duration: 3,
      });
    },
    getData(res) {
      var arr = res.result.slice(0, 3000); // res.result.items;
      var positions = [];
      var lineCoods = [];
      for (let i = 0; i < arr.length; i++) {
        var item = arr[i];
        var pos = Cesium.Cartesian3.fromDegrees(item.longitude, item.latitude);
        positions.push(pos);

        lineCoods.push([item.longitude, item.latitude]);
      }

      positions = this.removeDuplicate(positions); //去重

      var entity = DBentityCollection.getById("轨迹信息");
      var text = `轨迹名称(${this.searchForm.name})`;
      if (!entity) {
        entity = this.createFlydEntity(positions[0], "轨迹信息", text, positions);
        DBentityCollection.add(entity);
      }
      viewer.flyTo(entity, {
        duration: 3,
      });
    },

    createFlydEntity(center, id, text, positions) {
      const entity = new Cesium.Entity({
        id: id,
        position: center,
        label: {
          text: text || "设备",
          verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
          font: "16px sans-serif",
          pixelOffset: new Cesium.Cartesian2(0, -20), //6,229,72
          fillColor: new Cesium.Color(6 / 255, 229 / 255, 72 / 255),
        },
        model: {
          show: true,
          uri: "data/mx/feiji.glb", //模型的地址
          scale: modelScale, //模型缩放比例
          minimumPixelSize: modelMinimumPixelSize, //
          maximumScale: 20000, // 模型的最大比例尺大小。 minimumPixelSize的上限
          incrementallyLoadTextures: true, // 加载模型后纹理是否可以继续流入
          runAnimations: true, // 是否应启动模型中指定的glTF动画
          clampAnimations: true, // 指定glTF动画是否应在没有关键帧的持续时间内保持最后一个姿势
          shadows: Cesium.ShadowMode.ENABLED,
          heightReference: Cesium.HeightReference.NONE, //设置模型贴地,
        },
        polyline: {
          positions: positions,
          width: 10,
          //granularity: 10, // 减少granularity可以减少顶点数量
          material: new Cesium.PolylineArrowMaterialProperty(
            Cesium.Color.fromRandom({
              alpha: 1.0,
            })
          ),
        },
      });
      return entity;
    },
    coordinatesToPos(coordinates) {
      var positions = [];
      for (let i = 0; i < coordinates.length; i++) {
        var coord = coordinates[i];
        var pos = Cesium.Cartesian3.fromDegrees(coord[0], coord[1]);
        positions.push(pos);
      }

      return positions;
    },
    removeDuplicate(positions) {
      if (positions.length < 2) {
        return positions;
      }
      let res = [];
      let j = 0;
      res.push(positions[0]);
      for (let i = 1; i < positions.length; i++) {
        if (
          res[j].x == positions[i].x &&
          res[j].y == positions[i].y &&
          res[j].z == positions[i].z
        ) {
          continue;
        }
        j++;
        res.push(positions[i]);
      }
      return res;
    },
    createBillboardEntity(center, positions) {
      const entity = new Cesium.Entity({
        id: "轨迹信息",
        position: center,
        billboard: {
          image: "data/img/marker/mark2.png",
          scale: 1.0,
          horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
          verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
          heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
        },
        polyline: {
          positions: positions,
          width: 10,
          //granularity: 10, // 减少granularity可以减少顶点数量
          material: new Cesium.PolylineArrowMaterialProperty(Cesium.Color.YELLOW),
          clampToGround: true,
        },
      });
      return entity;
    },
    exportFilter() {
      getCommonAjax("/location/exportLocation", this.searchForm, "arraybuffer")
        .then((res) => {
          this.downloadJsonFile(res, "轨迹信息记录_" + new Date().getTime() + ".xlsx");
        })
        .catch((err) => {
          console.error(err);
        });
    },
    downloadJsonFile(data, fileName) {
      var blob = new Blob([data], { type: "application/octet-stream" });
      var url = URL.createObjectURL(blob);
      var link = document.createElement("a");
      link.download = fileName;
      link.href = url;
      link.click();
      URL.revokeObjectURL(url);
    },
    handleFilter() {
      this.searchForm.page = 1;
      if(!this.searchForm.beginTime){
        this.searchForm.beginTime=getPreviousDate(30)
      }
      if(!this.searchForm.endTime){
        this.searchForm.endTime=getCurrentEndTime()
      }
      this.$refs["YzTable"].getList(this.searchForm, true);
    },
    addCard() {
      this.$dialog.open({
        title: "添加设备",
        shade: true,
        area: {
          height: "350px",
          width: "400px",
        },
        location: {
          top: null,
          left: null,
          bottom: "300px",
          right: "20px",
        },
        content: {
          type: "vue",
          subCom: Add,
        },
      });
    },
    handleEdit(index, row) {
      console.log(index, row);
    },
    handleDelete(index, row) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deletedUser({ id: row.id })
            .then(() => {
              this.getList();
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            })
            .catch((e) => {
              //this.$message.error(e);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.filterBg {
  display: flex;
  justify-content: space-between;
}
</style>
